<template>
  <div>
    <div class="text-center">
      <b-card-text class="mt-2 h4 color-inherit text-reset"> Create New Group </b-card-text>
    </div>
    <b-list-group class="mt-3 rounded-0">
      <b-list-group-item class="bg-transparent">
        <b-form-group label="Group Name" label-for="lb_name">
          <b-form-input id="lb_name" v-model="name" placeholder="New Group Name" />
        </b-form-group>
      </b-list-group-item>
      <b-list-group-item class="bg-transparent right-align">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          variant="primary"
          class="mr-1"
          :disabled="name === ''"
          @click="onClickCreateGroup()"
        >
          Create
        </b-button>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>
<script>
import Ripple from 'vue-ripple-directive'
import { BCardText, BListGroup, BListGroupItem, BFormGroup, BFormInput, BButton } from 'bootstrap-vue'

export default {
  components: {
    BCardText,
    BListGroup,
    BListGroupItem,
    BFormGroup,
    BFormInput,
    BButton
  },
  directives: {
    Ripple
  },
  data: function () {
    return {
      name: ''
    }
  },
  methods: {
    async onClickCreateGroup() {
      await this.$store.dispatch('homeAddNew/createGroup', { self: this, organisationId: this.$route.params.organisationId, name: this.name })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables/_variables';

.list-group-item {
  border: none !important;
}
.btn-add {
  height: 30px;
  border-top-left-radius: unset;
  border-bottom-left-radius: unset;
  margin-right: 0 !important;
  padding: 0.5rem;
}

.btn-remove-user {
  height: 30px;
  padding: 0.5rem;
  margin-right: 0 !important;
}

.card-title {
  margin-bottom: 0.2rem;
}

p {
  color: $text-muted;
}
</style>
